const AppContainer = (props) => {
  return props.children;
};

export default AppContainer;
